export default __webpack_public_path__ + "static/media/defaultGalleryIcon.998e6a56.svg";